import React, { useContext } from 'react';
import {useTranslation} from "react-i18next";
import i18next from "i18next";
import {GAME_ROUTE} from "../../utils/consts";
import {NavLink} from "react-router-dom";
import device from "current-device";
import {ScrollToPosition} from "../../utils/ScrollToPosition";
import {PopupContext} from "../../App";
import {observer} from "mobx-react-lite";

const GameBox = ({game}) => {
    const {t} = useTranslation();
    const [, setPopupContext] = useContext(PopupContext);

    const handlePopup = (e) => {
        if (!device.mobile()) {
            e.preventDefault();
            ScrollToPosition(false, window.pageYOffset);
            setPopupContext(e.target.closest('a').href)
        }
    };

    return (
        <div className={`box ${game.top_game ? 'top' : ''} ${game.game_new ? 'new' : ''}`}>
            {game.top_game ? <div className="top"><span>{t('Top')}</span></div> : null}
            {game.game_new ? <div className="new"><span>{t('New')}</span></div> : null}
            <div className="box_img">
                {game.image.indexOf('.svg') > 0
                    ? <object type="image/svg+xml" data={game.image}>
                        <img src={game.image} alt={game.name}/>
                    </object>
                    : <img src={game.image} alt={game.name}/>
            }
        </div>
    <div className="box_description">
    <div className="box_title">
                    <h1>{game.name}</h1>
                    <div className="key">
                        <span>ID</span>
                        <span className="number">{game.game_id}</span>
                    </div>
                </div>
                <div className="box_inf">
                    <table>
                        <tbody>
                        <tr className="type">
                            <td>{t('Type')}:</td>
                            <td className="inf">
                                {game.game_type === 'slot' ? t('slot') : null}
                                {game.game_type === 'balls' ? t('Balls') : null}
                                {game.game_type === 'table' ? t('Table') : null}
                                {game.game_type === 'scratchcards' ? t('Scratchcards') : null}
                            </td>
                        </tr>
                        <tr className="free">
                            <td>{t('Free games')}:</td>
                            <td className="inf">
                                {game.free_game ? t('Yes') : t('No')}
                            </td>
                        </tr>
                        <tr className="reels">
                            <td>{t('Reels')}:</td>
                            <td className="inf">{game.game_reels === 0 ? t('No') : game.game_reels}</td>
                        </tr>
                        <tr className="bonus">
                            <td>{t('Bonus game')}:</td>
                            <td className="inf">
                                {game.bonus_game ? t('Yes') : t('No')}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="box_button">
                    <a
                        onClick={handlePopup}
                        href={game.play_game_url}
                    ><span>{t('Play')}</span></a>
                    <NavLink to={`/${i18next.language}${GAME_ROUTE}/${game.id}/`}>
                        <span>{t('READ MORE')}</span>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default observer(GameBox);